import { render, staticRenderFns } from "./TherapyDateOfBirth.vue?vue&type=template&id=326c9e57"
import script from "./TherapyDateOfBirth.vue?vue&type=script&lang=js"
export * from "./TherapyDateOfBirth.vue?vue&type=script&lang=js"
import style0 from "./TherapyDateOfBirth.vue?vue&type=style&index=0&id=326c9e57&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports